import { SvgIcon } from '@mui/material';

export default function LaneRightIcon(props) {
  return (
    <SvgIcon fill='none' fontSize='large' {...props}>
      <path d='M6.64999 17.3077L5.94229 16.6L10.5365 12L5.94229 7.40002L6.64999 6.69232L11.9577 12L6.64999 17.3077ZM12.75 17.3077L12.0423 16.6L16.6365 12L12.0423 7.40002L12.75 6.69232L18.0577 12L12.75 17.3077Z' />
    </SvgIcon>
  );
}
